import { all, fork } from 'redux-saga/effects';
import { listSkusSaga, listSkusOnLabParentSelectSaga } from './list-skus';
export function* rootSaga() {
    yield all([fork(listSkusSaga), fork(listSkusOnLabParentSelectSaga)]);
}
